import React from "react";

import { Box } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

const Footer = ({ loading, name, onSubmit, onClose }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
        }}
    >
        <StandartButton
            onClick={onClose}
            disabled={loading}
            variant={ButtonVariant.BLACK_OUTLINED}
        >
            Close
        </StandartButton>
        <StandartButton
            onClick={onSubmit}
            disabled={!name || loading}
            variant="contained"
            color="primary"
            isLoading={loading}
        >
            Save
        </StandartButton>
    </Box>
);

export default Footer;
